module.exports = __webpack_public_path__ + "img/zj.be76f4d9.png";